import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useLeadFormModalControls = (uid: string) => {
    const controls = useBrowserModalControls(`lead-form-modal-${uid}`);

    return {
        isLeadFormModalOpen: controls.isModalOpen,
        openLeadFormModal: controls.openModal,
        closeLeadFormModal: controls.closeModal,
    };
};
